<template>
  <div>
    {{ resource.displayName }}
  </div>
</template>

<script>
export default {
  name: "resource",
  props: ["res"],
  computed: {
    resource() {
      return this.$store.getters["resources/byId"](this.res);
    },
  },
};
</script>

<style></style>
